import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/useAuthStore";
import { useProposalStore } from "../store/useProposalStore";
import { Plus } from "lucide-react";
import ProposalList from "../components/proposals/ProposalList";
import ProposalAnalytics from "../components/proposals/ProposalAnalytics";

const ProposalsPage = () => {
  const navigate = useNavigate();
  const { authUser } = useAuthStore();
  const { fetchProposals, fetchStats } = useProposalStore();

  useEffect(() => {
    if (authUser?._id) { fetchProposals(); fetchStats(); }
  }, [authUser, fetchProposals, fetchStats]);

  const isBD = authUser?.role === "Business Developer";

  return (
    <div className={`min-h-screen bg-background px-4 lg:px-8 pb-10 ${isBD ? "pt-8" : "pt-20"}`}>
      <div className="max-w-[1400px] mx-auto flex flex-col gap-6">
        <section className="bg-surface-container-lowest rounded-xl border border-outline-variant card-shadow p-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <h1 className="text-[26px] font-bold text-on-surface tracking-tight">
              {isBD ? "Proposal Templates" : "Proposals Overview"}
            </h1>
            <p className="text-[14px] text-on-surface-variant mt-1">
              {isBD
                ? "Create, organize, and reuse proposals for your client projects"
                : "All proposals across the team — see who created each one"}
            </p>
          </div>
          {/* Only BDs author proposals; admins/others get a read-only overview. */}
          {isBD && (
            <button
              onClick={() => navigate("/proposal-builder")}
              className="bg-primary text-white text-sm font-semibold px-5 py-2.5 rounded-lg flex items-center gap-2 hover:bg-[#004b9e] transition-colors shrink-0"
            >
              <Plus size={18} /> Create Proposal
            </button>
          )}
        </section>

        <ProposalAnalytics />

        <section className="bg-surface-container-lowest rounded-xl border border-outline-variant card-shadow p-4 lg:p-6">
          <ProposalList />
        </section>
      </div>
    </div>
  );
};

export default ProposalsPage;
